import { CalendarDays, ExternalLink, MapPin } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'

export interface OwnedPortalEvent {
  name: string
  schedule: string
  location: string | null
  sourceUrl: string
}

export function OwnedPortalEventPage({ event }: { event: OwnedPortalEvent }) {
  return (
    <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
      <section className="space-y-4">
        <h1 className="text-heading-lg font-normal tracking-tight">{event.name}</h1>
        <div className="space-y-1.5 text-caption">
          <p className="flex items-center gap-2 font-medium text-primary">
            <CalendarDays className="size-3.5" aria-hidden="true" />
            {event.schedule}
          </p>
          {event.location && (
            <p className="flex items-center gap-2 text-muted-foreground">
              <MapPin className="size-3.5" aria-hidden="true" />
              {event.location}
            </p>
          )}
        </div>
      </section>

      <Card className="h-fit overflow-hidden lg:sticky lg:top-6">
        <CardHeader className="border-b border-border px-4 py-3">
          <CardTitle className="text-body-sm">Registration</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 p-4">
          <dl className="space-y-2 text-body-sm">
            <div className="flex justify-between gap-4">
              <dt className="text-muted-foreground">When</dt>
              <dd className="text-right">{event.schedule}</dd>
            </div>
            {event.location && (
              <div className="flex justify-between gap-4">
                <dt className="text-muted-foreground">Where</dt>
                <dd className="text-right">{event.location}</dd>
              </div>
            )}
          </dl>
        </CardContent>
        <CardFooter className="border-t border-border p-0 px-4 py-3">
          <Button asChild className="w-full">
            <a href={event.sourceUrl} target="_blank" rel="noopener noreferrer">
              Book tickets
              <ExternalLink className="ml-1.5 size-4" aria-hidden="true" />
            </a>
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
